import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CustomModulesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CustomModules",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M2.97 2.93c-.44.33-.51.65-.29 1.64s.66 4.95 3.18 6.35c2.53 1.41 6.1-2.09 4.53-4.57S6.03 4.69 5.17 3.87s-1.3-1.51-2.2-.95ZM13.38 9.51l.06.06c.37.37.37.96 0 1.33l-2.85 2.85c-.37.37-.96.37-1.33 0l-.06-.06a.936.936 0 0 1 0-1.33l2.85-2.85c.37-.37.97-.37 1.33 0M29.23 25.32l-9.59-9.58 4.04-4.04c.29.06.63.09.97.09 2.71 0 4.9-2.2 4.9-4.91v-.02c0-.62-.12-1.21-.31-1.75l-2.36 2.31c-.32.32-.77.54-1.28.54s-.95-.21-1.28-.54c-.38-.38-.63-.92-.63-1.52s.24-1.13.63-1.52l2.1-2.03c-.53-.21-1.13-.32-1.78-.32a4.912 4.912 0 0 0-4.82 5.86v-.03l-4.05 4.04-.58-.58-3.79 3.96.51.5-9.11 9.08c-.5.51-.8 1.18-.8 1.93 0 1.51 1.23 2.73 2.73 2.73.75 0 1.44-.3 1.93-.81l9.09-9.1 9.59 9.57c.5.5 1.18.8 1.93.8 1.51 0 2.73-1.23 2.73-2.73a2.63 2.63 0 0 0-.77-1.93M4.3 27.96a.696.696 0 1 1 0-1.39c.39 0 .7.3.7.69s-.31.7-.7.7"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M18.56 31.86h-7.48c-1.77 0-3.22-1.44-3.22-3.22v-7.48c0-.86.34-1.67.94-2.27L18.88 8.81c1.21-1.22 3.33-1.22 4.55 0l7.48 7.48c.61.61.94 1.42.94 2.28s-.33 1.67-.94 2.28L20.83 30.93c-.61.61-1.42.94-2.28.94Zm-8.42-10.71v7.48c0 .51.42.93.93.93h7.48c.25 0 .48-.1.66-.27l10.08-10.08c.18-.18.27-.41.27-.66s-.1-.48-.27-.66l-7.48-7.48a.96.96 0 0 0-1.32 0L10.41 20.49c-.17.17-.27.41-.27.66"
      }), /*#__PURE__*/_jsx("path", {
        d: "M27.38 23.9c-.29 0-.58-.11-.81-.33L16.15 13.15c-.45-.45-.45-1.17 0-1.62s1.17-.45 1.62 0l10.42 10.42a1.14 1.14 0 0 1-.81 1.95M28.43 31.86h-1.14a1.14 1.14 0 1 1 0-2.28h1.14c.63 0 1.14-.51 1.14-1.14V27.3a1.14 1.14 0 1 1 2.28 0v1.14c0 1.89-1.54 3.43-3.43 3.43ZM4.43 31.86H3.29c-1.89 0-3.43-1.54-3.43-3.43v-1.14a1.14 1.14 0 1 1 2.28 0v1.14c0 .63.51 1.14 1.14 1.14h1.14a1.14 1.14 0 1 1 0 2.28ZM30.72 5.57c-.63 0-1.14-.51-1.14-1.14V3.29c0-.63-.51-1.14-1.14-1.14H27.3a1.14 1.14 0 1 1 0-2.28h1.14c1.89 0 3.43 1.54 3.43 3.43v1.14c0 .63-.51 1.14-1.14 1.14ZM1 5.57c-.63 0-1.14-.51-1.14-1.14V3.29C-.14 1.4 1.4-.14 3.29-.14h1.14a1.14 1.14 0 1 1 0 2.28H3.29c-.63 0-1.14.51-1.14 1.14v1.14c0 .63-.51 1.14-1.14 1.14ZM1 23.86c-.63 0-1.14-.51-1.14-1.14v-4.57a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14M1 14.71c-.63 0-1.14-.51-1.14-1.14V9a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14M30.71 12.43c-.63 0-1.14-.51-1.14-1.14V9a1.14 1.14 0 1 1 2.28 0v2.29c0 .63-.51 1.14-1.14 1.14M22.71 2.14h-4.57a1.14 1.14 0 1 1 0-2.28h4.57a1.14 1.14 0 1 1 0 2.28M13.57 2.14H9A1.14 1.14 0 1 1 9-.14h4.57a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};
CustomModulesIcon.displayName = 'CustomModulesIcon';